import { FC } from "react";
import Button from "components/shared/Button";
import { HomeHeroImage } from "assets/images";

interface Props {
  title: string;
  subtitle: string;
  imageSrc?: string;
  imageWebpSrcSet?: string;
  imageFallbackSrcSet?: string;
  imageSizes?: string;
  imageWidth?: number;
  imageHeight?: number;
  imageAlt?: string;
  secondaryAction?: { label: string; onClick: () => void };
  primaryAction?: { label: string; href: string };
  showPrimaryAction?: boolean;
}

const HERO_IMAGE_SIZES =
  "(min-width: 1362px) 1234px, " +
  "(min-width: 768px) calc(100vw - 128px), " +
  "calc(100vw - 32px)";

export const HeroSection: FC<Props> = ({
  title,
  subtitle,
  imageSrc = HomeHeroImage,
  imageWebpSrcSet,
  imageFallbackSrcSet,
  imageSizes = HERO_IMAGE_SIZES,
  imageWidth,
  imageHeight,
  imageAlt = "Hero Banner",
  secondaryAction,
  primaryAction,
  showPrimaryAction = true,
}) => {
  const primaryLabel = primaryAction?.label ?? "Create Profile";
  const primaryHref =
    primaryAction?.href ?? `https://auth.${process.env.REACT_APP_DOMAIN}`;

  return (
    <section className="bg-white">
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col justify-center items-center gap-8 referral-container">
          <div className="flex flex-col gap-6 md:gap-8 text-center">
            <p className="text-blueShades-4 text-5xl font-SatoshiBold lg:w-[22ch] m-auto">
              {title}
            </p>
            <p className="text-ashShade-16 text-xl md:text-lg font-SatoshiMedium lg:w-[660px] m-auto">
              {subtitle}
            </p>
          </div>
          <div className="div flex gap-6">
            {showPrimaryAction && (
              <a
                href={primaryHref}
                rel="noopener noreferrer"
                className="flex flex-col"
              >
                <Button
                  label={primaryLabel}
                  className={"!bg-blueShades2-1 !border-blueShades2-1"}
                  style={{
                    backgroundColor: "#023061",
                    borderColor: "#023061",
                  }}
                />
              </a>
            )}
            {secondaryAction && (
              <Button
                label={secondaryAction.label}
                className="border"
                style={{
                  backgroundColor: "#023061",
                  borderColor: "#023061",
                }}
                onClick={secondaryAction.onClick}
              />
            )}
          </div>
          <picture className="block w-full">
            {imageWebpSrcSet && (
              <source
                type="image/webp"
                srcSet={imageWebpSrcSet}
                sizes={imageSizes}
              />
            )}

            <img
              src={imageSrc}
              srcSet={imageFallbackSrcSet}
              sizes={imageFallbackSrcSet ? imageSizes : undefined}
              width={imageWidth}
              height={imageHeight}
              alt={imageAlt}
              className="block w-full h-auto"
            />
          </picture>
        </div>
      </div>
    </section>
  );
};
